import { Component, ChangeDetectionStrategy, input, computed, inject } from '@angular/core';
import { IrisFilesService } from '@iris/common/modules/dms/services/files.service';
import { BaseFileAction } from '@iris/modules/dms/components/file-actions/base-file-action';
import { IrisPreviewFileService } from '@iris/common/modules/preview-file/services/preview-file.service';
import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { IrisDMSFileI } from '@iris/common/modules/dms/models/IrisDMSFile';
import { IrisDmsFilesSandbox } from '@iris/common/modules/dms/sandbox/dms-files.sandbox';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-file-preview-button',
  imports: [
    NgClass,
    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  templateUrl: './dms-file-preview-button.component.html',
  styleUrls: ['./dms-file-preview-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsFilePreviewButtonComponent extends BaseFileAction {
  private readonly filesService = inject(IrisFilesService);
  private readonly previewFileService = inject(IrisPreviewFileService);
  private readonly dmsModalsSandbox = inject(IrisDmsModalsSandbox);
  private readonly dmsFilesSandbox = inject(IrisDmsFilesSandbox);

  readonly versionId = input<string>();
  readonly files = input<IrisDMSFileI[]>();

  readonly label = 'label.Preview';

  readonly fileDisabled = computed(() => !this.filesService.isPreviewReady(this.file()));

  readonly tooltipLabel = computed(() => this.filesService.isPreviewInProgress(this.file())
    ? this.translateService.instant('text.dms.PreviewWillBeAvailableSoon')
    : this.title);

  showFilePreview(): void {
    if (this.dmsFilesSandbox.isFileEditable(this.file())) {
      this.dmsModalsSandbox.showOfficeEditorModal(this.file());
      return;
    }
    if (this.files() && this.files().length > 0) {
      this.previewFileService.openPreviewFileModal({
        fileInfo: this.file(),
        filesList: this.files(),
        saveRecentFile: true,
      });
    } else {
      this.dmsModalsSandbox.showFilePreviewModal(this.file(), this.versionId(), true);
    }
  }
}
